import React, {Component, Fragment} from "react";
import StandardTable from "../../components/StandardTable";
import authWrapper from "../../utils/authWrapper";
import {Divider, InputNumber, Popconfirm} from "antd";
import FormModal from "../../components/FormModal";
import * as api from "../../api/packingSlip";


const EditFragment = authWrapper('detail/edit')(Fragment);
const DeletePopConfirm = authWrapper('detail/delete')(Popconfirm);


export const editModalFields = [
    {
        dataIndex: 'id',
        visible: false,
    },
    {
        title: '装运数量',
        dataIndex: 'packing_qty',
        render: (
            <InputNumber style={{width: '100%'}} />
        )
    },
]

class PackingSlipDetail extends Component {

    dataTable = null;

    columns = [
        {
            title: '产品ID',
            dataIndex: 'product_no'
        },
        {
            title: '采购单号',
            dataIndex: 'purchase_no',
        },
        {
            title: '行号',
            dataIndex: 'line_no',
        },
        {
            title: '物料编号',
            dataIndex: 'product_id',
        },
        {
            title: '装运数量',
            dataIndex: 'packing_qty',
        },
        {
            title: '剩余数量',
            dataIndex: 'remain_qty',
        },
        {
            title: '操作',
            render: (record) => (
                <span>
                    {this.props.record.status !== 1 && (
                        <Fragment>
                            <EditFragment>
                                <a onClick={() => this.onEditModalShow(record)}>编辑</a>
                                <Divider type={'vertical'} />
                            </EditFragment>
                            <DeletePopConfirm title={'是否确认删除'} onConfirm={() => this.onDelete(record.id)}>
                                <a>删除</a>
                            </DeletePopConfirm>
                        </Fragment>
                    )}
                </span>
            )
        },
    ]

    state = {
        selectedRecord: null,

        editModalVisible: false,
        editModalSaving: false,
    }

    onEditModalShow = (record) => {
        this.setState({
            selectedRecord: record,
            editModalVisible: true
        })
    }

    onEditModalOk = (fieldsValue) => {
        this.setState({editModalSaving: true})
        api.modifyDetail(fieldsValue.id, fieldsValue['packing_qty']).then(() => {
            this.setState({editModalSaving: false, editModalVisible: false})
            this.dataTable.fetch()
        }).catch(() => {
            this.setState({editModalSaving: false})
        })
    }

    onDelete = (detailId) => {
        api.deleteDetail(detailId).then(() => {
            this.dataTable.fetch()
        })
    }

    render() {
        const {id} = this.props.record;
        return (
            <div>
                <StandardTable url={'/api/packing/slip/details?packing_id=' + id}
                               columns={this.columns}
                               ref={table => this.dataTable = table}
                />
                <FormModal fields={editModalFields}
                           visible={this.state.editModalVisible}
                           record={this.state.selectedRecord}
                           onCancel={() => this.setState({editModalVisible: false})}
                           onOk={this.onEditModalOk}
                           confirmLoading={this.state.editModalSaving}
                />
            </div>
        );
    }
}

export default PackingSlipDetail;